import { Box } from "@mui/material";
import React from "react";

import { useMortgageState } from "../../../../../contexts/mortgage/Reducer";
import MortgageRowMobile from "./MortgageRowMobile";
import MortgageTotalMobile from "./MortgageTotalMobile";

const MortgageDetailSummaryMobile = () => {
    const { newMortgage } = useMortgageState();

    return (
        <Box mt={"40px"}>
            <Box>
                {newMortgage && (
                    <MortgageRowMobile mortgage={newMortgage} isNew={true} key={`mortgage-${newMortgage.id}`} />
                )}
                {newMortgage?.otherLiabilities &&
                    newMortgage.otherLiabilities
                        .filter((otherMortgage) => otherMortgage.amount > 0)
                        .map((otherMortgage, index) => (
                            <MortgageRowMobile
                                mortgage={{
                                    ...otherMortgage,
                                    currency: otherMortgage.currency ?? newMortgage.currency,
                                }}
                                isNew={false}
                                key={`other-mortgage-${index}`}
                            />
                        ))}
            </Box>
            <MortgageTotalMobile newMortgage={newMortgage} />
        </Box>
    );
};
export default MortgageDetailSummaryMobile;
